import { attr } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';

const SingleCheckoutOrderPreview = ApplicationRecord.extend({
  attrs: {
    customer_id: attr({ type: String }),
    delivery_date: attr({ type: String }),
    delivery_option_id: attr({ type: Number }),

    recipe_contents: attr({ type: Array }),
    product_contents: attr({ type: Array }),

    purchase_value: attr({ type: String, persist: false }),
    discount_amount: attr({ type: String, persist: false }),
    credit_balance_amount: attr({ type: String, persist: false }),
    external_payment_amount: attr({ type: String, persist: false }),
    shipping_amount: attr({ type: String, persist: false }),
    minimum_order_value: attr({ type: String, persist: false }),
  },
  static: {
    endpoint: '/single_checkout_order_previews',
    jsonapiType: 'payments-single_checkout_order_previews',
  },
});

export default SingleCheckoutOrderPreview;
